import React from 'react';
import UpcomingEventsList from '../../events_index/components/upcoming_events_list/upcoming_events_list';
import PastEventsList from '../../events_index/components/past_events_list/past_events_list';
import styles from './events.module.scss';

interface Props {
  showUpcomingEvents: boolean;
  showPastEvents: boolean;
}

const Events: React.FC<Props> = ({ showUpcomingEvents, showPastEvents }) => {
  return (
    <>
      {showUpcomingEvents && (
        <>
          <h3 className='fs-125 mb-45'>
            Upcoming <span className={styles.highlightedTitle}>Events</span>
          </h3>
          <UpcomingEventsList
            numberOfEventsOnMount={3}
            showAllEventsLogic={false}
            plausibleSection={'home-page'}
          />
        </>
      )}
      {showPastEvents && (
        <>
          <div className='mt-5'>
            <h3 className='fs-125 mb-45'>
              Past Events
            </h3>
          </div>
          <PastEventsList
            showMoreEventsLogic={false}
            numberOfEvents={4}
            plausibleSection={'home-page'}
          />
        </>
      )}
    </>
  );
};

export default Events;
